export default __webpack_public_path__ + "static/media/spinnerDark.4177e530.gif";